ACC.stickyBtn = {
    _autoload: [
        ['initialize', $('.js-sticky').length && $('.js-sticky-anchor').length],
    ],

    initialize() {
        ACC.stickyBtn.fillStickyBlock();
        ACC.stickyBtn.addScrollHandler();

        $(window).trigger('scroll');
    },

    fillStickyBlock() {
        const totalPrice = $('.js-total-price').html();
        const pageTitle = $('.js-page-title').html();

        $('.sticky-block__price').html(totalPrice);
        if (pageTitle) {
            $('.sticky-block__text').html(pageTitle);
        }
    },

    addScrollHandler() {
        const $window = $(window);
        const windowHeight = $(window).height();
        const $stickyBlock = $('.sticky-block');
        const $element = $('.sticky-block--checkout, .sticky-block--pdp');
        const anchor = $('.js-sticky-anchor').offset().top;
        const anchorHeight = $('.js-sticky-anchor').outerHeight();

        $window.on('scroll', () => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                const $scrollTop = $window.scrollTop();
                let result;

                if ($element.length !== 0) {
                    result = $scrollTop + windowHeight > anchor;
                } else {
                    result = $scrollTop < anchor + anchorHeight;
                }

                if (result) {
                    $stickyBlock.fadeOut(200);
                } else {
                    $stickyBlock.fadeIn(200);
                }
            }
        });

        $window.on('resize', () => {
            if (window.matchMedia('(min-width: 767px)').matches) {
                $stickyBlock.fadeOut(200);
            }
        });
    },
};
